import { Link } from 'react-router-dom';

export default function HeroSection() {
  const scrollToQuiz = () => {
    const quizSection = document.getElementById('quiz');
    if (quizSection) {
      quizSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/129367f3f9d267754316533c71fb5f41.png)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-blue-900">
          Khám Phá Thương Hiệu<br />
          Your Name - Your Brand - Success
        </h1>
        
        <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed text-white/90">
          Trắc nghiệm miễn phí giúp bạn xác định phong cách thương hiệu cá nhân phù hợp nhất, 
          từ đó xây dựng thương hiệu ấn tượng và thu hút
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToQuiz}
            className="whitespace-nowrap px-10 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-lg font-semibold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 cursor-pointer"
          >
            Bắt Đầu Trắc Nghiệm
          </button>
          <Link
            to="#introduction"
            className="whitespace-nowrap px-10 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer"
          >
            Tìm Hiểu Thêm
          </Link>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-500/20 rounded-xl mb-4 mx-auto">
              <i className="ri-questionnaire-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">8 Câu Hỏi</h3>
            <p className="text-white/80">Trắc nghiệm nhanh chóng và chính xác</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-500/20 rounded-xl mb-4 mx-auto">
              <i className="ri-lightbulb-flash-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">Gợi Ý Chi Tiết</h3>
            <p className="text-white/80">Nhận phân tích và lời khuyên cụ thể</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-500/20 rounded-xl mb-4 mx-auto">
              <i className="ri-star-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">Hoàn Toàn Miễn Phí</h3>
            <p className="text-white/80">Không cần đăng ký hay thanh toán</p>
          </div>
        </div>
      </div>
    </section>
  );
}
